import React, { useEffect, useState } from 'react';
import { AwardIcon, BriefcaseIcon, TrendingUpIcon, ShieldCheckIcon, ArrowRightIcon } from 'lucide-react';
const Home = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    const targetDate = new Date('2026-03-16T00:00:00').getTime();
    const calculate = () => {
      const now = new Date().getTime();
      const diff = Math.max(0, targetDate - now);
      setTimeLeft({
        days: Math.floor(diff / (1000 * 60 * 60 * 24)),
        hours: Math.floor(diff % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
        minutes: Math.floor(diff % (1000 * 60 * 60) / (1000 * 60)),
        seconds: Math.floor(diff % (1000 * 60) / 1000)
      });
    };
    calculate();
    const interval = setInterval(calculate, 1000);
    return () => clearInterval(interval);
  }, []);
  const stats = [{
    number: '4,500+',
    label: 'Certified Developers',
    icon: AwardIcon
  }, {
    number: '50+',
    label: 'Hiring Companies',
    icon: BriefcaseIcon
  }, {
    number: '100+',
    label: 'Job Openings',
    icon: TrendingUpIcon
  }, {
    number: '15+',
    label: 'Certifications',
    icon: ShieldCheckIcon
  }];
  const technologies = [{
    name: 'Laravel',
    url: 'https://upload.wikimedia.org/wikipedia/commons/9/9a/Laravel.svg'
  }, {
    name: 'React',
    url: 'https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg'
  }, {
    name: 'Vue.js',
    url: 'https://upload.wikimedia.org/wikipedia/commons/9/95/Vue.js_Logo_2.svg'
  }, {
    name: 'PHP',
    url: 'https://upload.wikimedia.org/wikipedia/commons/2/27/PHP-logo.svg'
  }, {
    name: 'TypeScript',
    url: 'https://upload.wikimedia.org/wikipedia/commons/4/4c/Typescript_logo_2020.svg'
  }, {
    name: 'Node.js',
    url: 'https://upload.wikimedia.org/wikipedia/commons/d/d9/Node.js_logo.svg'
  }, {
    name: 'Tailwind CSS',
    url: 'https://upload.wikimedia.org/wikipedia/commons/d/d5/Tailwind_CSS_Logo.svg'
  }, {
    name: 'Git',
    url: 'https://upload.wikimedia.org/wikipedia/commons/3/3f/Git_icon.svg'
  }, {
    name: 'AWS',
    url: 'https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg'
  }];
  return <div className="min-h-screen bg-[#0F1115] relative overflow-hidden text-white font-sans" data-id="element-909">
      {/* Global Grain Texture */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none z-50 bg-grain mix-blend-overlay" data-id="element-910"></div>

      {/* Background Blobs */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-911">
        <div className="absolute top-[-10%] left-[-10%] w-[40rem] h-[40rem] bg-gradient-to-br from-[#d73b3e]/20 to-transparent rounded-full blur-3xl opacity-50 animate-pulse" data-id="element-912" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[40rem] h-[40rem] bg-gradient-to-br from-orange-500/20 to-transparent rounded-full blur-3xl opacity-50 animate-pulse" style={{
        animationDelay: '2s'
      }} data-id="element-913" />
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 flex flex-col items-center justify-center min-h-screen py-20" data-id="element-914">
        {/* Main Content */}
        <div className="max-w-4xl mx-auto text-center mb-20" data-id="element-915">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/5 backdrop-blur-sm rounded-full border border-white/10 mb-8 animate-[fadeInUp_0.6s_ease-out]" data-id="element-916">
            <span className="relative flex h-2 w-2" data-id="element-917">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#d73b3e] opacity-75" data-id="element-918"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-[#d73b3e]" data-id="element-919"></span>
            </span>
            <span className="text-sm font-medium text-gray-300" data-id="element-920">
              Launching Soon
            </span>
          </div>

          <h1 className="font-display text-6xl md:text-7xl lg:text-8xl font-bold mb-8 leading-tight tracking-tight animate-[fadeInUp_0.8s_ease-out_0.2s_both]" data-id="element-921">
            Coming{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#d73b3e] to-orange-500" data-id="element-922">
              Soon
            </span>
          </h1>

          <p className="text-xl md:text-2xl text-gray-400 mb-12 leading-relaxed max-w-2xl mx-auto animate-[fadeInUp_0.8s_ease-out_0.4s_both]" data-id="element-923">
            The premier platform for certified developers. Verify your skills,
            showcase your expertise, and connect with top companies.
          </p>

          {/* Countdown Clock */}
          <div className="flex justify-center gap-4 sm:gap-6 mb-12 animate-[fadeInUp_0.8s_ease-out_0.5s_both]" data-id="element-924">
            {[{
            value: timeLeft.days,
            label: 'Days'
          }, {
            value: timeLeft.hours,
            label: 'Hours'
          }, {
            value: timeLeft.minutes,
            label: 'Minutes'
          }, {
            value: timeLeft.seconds,
            label: 'Seconds'
          }].map(unit => <div key={unit.label} className="flex flex-col items-center" data-id="element-925">
                <div className="w-[72px] h-[72px] sm:w-[88px] sm:h-[88px] bg-[#1a1d24] border border-gray-800 rounded-2xl flex items-center justify-center mb-2 shadow-lg" data-id="element-926">
                  <span className="text-3xl sm:text-4xl font-bold font-display tabular-nums text-white" data-id="element-927">
                    {String(unit.value).padStart(2, '0')}
                  </span>
                </div>
                <span className="text-xs sm:text-sm font-medium text-gray-500 uppercase tracking-wider" data-id="element-928">
                  {unit.label}
                </span>
              </div>)}
          </div>

          {/* CTA Button */}
          <div className="max-w-md mx-auto animate-[fadeInUp_0.8s_ease-out_0.6s_both]" data-id="element-929">
            <a href="https://20241363.sibforms.com/serve/MUIFANplGGYVCfViRB59tttKy9749n80I96D_x5m3-RVe4TgNHwg6XNg60Rldo60UK_bj2eo_JyEEetlr70HdEGD6taYgvjJm-ouPrDEPJYcC_kU-ke1agOGdXfpKaQTgFjYsW7uhKKLHQBHBTZ-vGCBGVjGkXOC8sBHHkyBzC1-b0Vbef-rKiMbiNoOt0sLK_ditP_1MY_nZ4Er" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 px-10 py-5 bg-gradient-to-r from-[#d73b3e] to-[#c02f32] hover:from-[#c02f32] hover:to-[#a02023] text-white rounded-xl font-semibold text-lg shadow-lg hover:shadow-red-500/25 transition-all duration-300 group" data-id="element-930">
              Pre-register for FREE profile creation
              <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-931" />
            </a>
            <p className="text-xs text-gray-500 mt-4" data-id="element-932">
              Join 4,500+ developers waiting for launch. No spam, ever.
            </p>
          </div>
        </div>

        {/* Technologies Grid */}
        <div className="w-full max-w-5xl mx-auto mb-20 animate-[fadeInUp_1s_ease-out_0.8s_both]" data-id="element-933">
          <p className="text-center text-sm font-medium text-gray-500 mb-8 uppercase tracking-wider" data-id="element-934">
            Some of the supported technologies
          </p>
          <div className="flex flex-wrap justify-center gap-6 md:gap-8 opacity-70 hover:opacity-100 transition-opacity duration-500" data-id="element-935">
            {technologies.map(tech => <div key={tech.name} className="w-16 h-16 md:w-20 md:h-20 bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10 flex items-center justify-center p-4 hover:bg-white/10 hover:scale-110 transition-all duration-300 hover:border-[#d73b3e]/30 group" title={tech.name} data-id="element-936">
                <img src={tech.url} alt={tech.name} className="w-full h-full object-contain grayscale group-hover:grayscale-0 transition-all duration-300" data-id="element-937" />
              </div>)}
          </div>
        </div>

        {/* Stats Section */}
        <div className="w-full max-w-6xl mx-auto animate-[fadeInUp_1s_ease-out_1s_both]" data-id="element-938">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-939">
            {stats.map((stat, index) => {
            const Icon = stat.icon;
            return <div key={index} className="bg-[#1a1d24]/50 backdrop-blur-sm border border-gray-800 rounded-2xl p-6 text-center hover:border-gray-700 transition-colors" data-id="element-940">
                  <div className="inline-flex items-center justify-center w-12 h-12 bg-gradient-to-br from-[#d73b3e]/10 to-orange-500/10 rounded-xl mb-4 border border-white/5" data-id="element-941">
                    <Icon className="w-6 h-6 text-[#d73b3e]" data-id="element-942" />
                  </div>
                  <div className="text-3xl font-bold text-white mb-1" data-id="element-943">
                    {stat.number}
                  </div>
                  <div className="text-sm font-medium text-gray-400" data-id="element-944">
                    {stat.label}
                  </div>
                </div>;
          })}
          </div>
        </div>
      </div>
    </div>;
};
export default Home;